<template>
    <component :is="clickable ? 'router-link' : 'div' " :to="clickable ? `/properties/${property.slug || property.id }` : null" class="d-block position-relative box-link" :class="imageCssClass">
        
        <div class="position-absolute top-0 start-0 end-0 css-height-transition" :style="`height:${imageSize}`">
            <property-card-image :property="property" height="100%" :class="imageCssClass" />
            <div style="background:linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.25) 80%, rgba(0,0,0,0.35) 100%)" class="position-absolute bottom-0 start-0 end-0 css-opacity-transition" :class="gradientCssClass">&nbsp;</div>
        </div>
        <div style="height:75%"><!-- spacer -->&nbsp;</div>
        <div class="position-absolute bottom-0 start-0 end-0 w-100 p-3 css-color-transition" :class="propNameCssClass">
            <container>
                <row>
                    <column :md="12">
                        <div class="d-flex align-items-center mb-1">
                            <div class="small text-uppercase" v-if="property.city && property.state">
                                {{ property.city }}, {{ property.state }} {{ (property.country && (property.country != 'US')) ? ', '+property.country : '' }}
                            </div>
                            <form-stars-rating v-if="property.cachedRatingsAvg" :value="Math.ceil(property.cachedRatingsAvg)" :readonly="true" class="mx-2 xx-small css-opacity-transition" :class="activeOpacityCssClass" />
                            <div v-if="property.cachedRatingsCount" class="small css-opacity-transition" :class="activeOpacityCssClass">
                                ({{ property.cachedRatingsCount }})
                            </div>
                        </div>

                        <h3 class="text-truncate mb-">{{ property.name }}</h3>
                    </column>
                    <column :md="12" class="d-flex align-items-baseline justify-content-start justify-content-md-end pt-1 pt-md-3 css-opacity-transition"  :class="activeOpacityCssClass">

                        <template v-if="property.isHotel && property.canBookHotelRooms" class="text-primary">
                            <div v-if="property.status == 2 || !property.hotelScheduleAvgRange">
                                Inquire for rates
                            </div>
                            <div v-else>
                                Avg. <span class="fs-5">${{ property.hotelScheduleAvgRange.replace('-', ' - $')+((property.hotelScheduleAvgRange.indexOf('-') != -1) ? ' ' : '') }}</span>/night
                            </div>
                        </template>

                        <template v-else>
                            <div v-if="property.status == 2 || !property.schedulePriceAvg">
                                Inquire for rates
                            </div>
                            <div v-else>
                                Avg. <span class="fs-5">{{ money(property.schedulePriceAvg) }}</span>/night
                            </div>
                        </template>

                        <ui-button size="sm" class="ms-3">
                            View Listing
                        </ui-button>

                    </column>
                </row>
            </container>
        </div>

        <div v-if="property.serviceLevel == 'W'" class="position-absolute top-0 end-0 text-primary me-2 mt-2 p-1">
            <div class="p-1 rounded-circle bg-body" :style="`width:${iconSize}px; height:${iconSize}px;`">
                <marquis-circle-icon />
            </div>
        </div>
    </component>
</template>

<script type="text/javascript">

    import PropertyCardImage from '@/components/Content/Public/Properties/Cards/Parts/Image.vue';
    import CommonComponents from '@/components/Common.vue';
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';

    import ApiObject from '@/classes/ApiObject.js';
    import Formatter from '@/classes/Formatter.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            MarquisCircleIcon,
            PropertyCardImage,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            active: {
                type: Boolean,
                default: false,
            },

            clickable: {
                type: Boolean,
                default: true, 
            }
        },

        computed: {

            imageSize() {
                if (this.active) {
                    return '100%';
                }
                return '75%';
            },

            gradientCssClass() {
                let cls = [];
                if (this.uiStore.isMobile) {
                    cls.push('top-0');
                }
                else {
                    cls.push('top-50');
                }
                if (this.active) {
                    cls.push('opacity-100');
                }
                else {
                    cls.push('opacity-0');
                }
                return cls;
            },

            activeOpacityCssClass() {
                if (this.active) {
                    return 'opacity-100';
                }
                return 'opacity-0';
            },

            iconSize() {
                if (this.uiStore.isMobile) {
                    return 36;
                }
                return 48;
            },

            imageCssClass() {
                if (this.uiStore.isMobile) {
                    return 'rounded-2';
                }
                
                return 'rounded-4';
            },

            propNameCssClass() {
                let cls = [];
                if (!this.active) {
                    cls.push('text-primary');
                }

                if (this.uiStore.isMobile) {
                    cls.push('rounded-bottom-2');
                }
                else {
                    cls.push('rounded-bottom-4');
                }
                return cls;
            },
            
        },

        methods: {
            money(amount) {
                return Formatter.money(amount, 0);
            },

            cardClick(evt) {
                if (
                    (!this.clickable) &&
                    (evt) &&
                    (evt.preventDefault)
                ) {
                    evt.preventDefault();
                    console.log('prevented');
                    console.log(evt.preventDefault);
                }
            },
        }
    };

</script>
